import HandleResponses from '@common/utils/handleResponses';
import tmsMdmAxiosInstance from '../../../tms-mdm-axios';
import tmsIndentAxiosInstance from '../../../tms-indent-axios';
import { getVehicleTypes } from '@/api-factory/vehicle-type';
import { getActiveTransporters } from '@/api-factory/transporter';

import axios from '../../../axios';

const actions = {
  async getDeliveries({ commit }, { params }) {
    try {
      const result = await axios.get('/deliveries', { params });
      if (result && !result.error) {
        if (result.data && result.data.length) {
          commit('APPEND_DELIVERIES', result.data);
        } else {
          commit('PAGINATION_CHECK', true);
        }
      }
      return result;
    } catch (err) {
      throw err;
    }
  },
  async discardDeliveries({ commit }, params) {
    try {
      const result = await axios.post('deliveries/discard', { data: params });
      commit('RESET_STATES');
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async getDeliveryDetails({ commit }, params) {
    try {
      const result = await axios.get('delivery_materials', { params });
      if (result && !result.error) {
        if (result.data) {
          commit('SET_REQUEST_DETAILS', result.data);
        }
        return result.data;
      }
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async getContracts({ commit }, payload) {
    try {
      const result = axios.put('planning/contract_routes', { data: payload });
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async getAllVehicles({ commit }, params) {
    try {
      const result = await getVehicleTypes(params);
      if (result && result.data) {
        commit('SET_MASTER_VEHICLE_LIST', result.data);
      }
      return result && result.data;
    } catch (error) {
      return error;
    }
  },
  async getNoFreightTransporters({ commit, state }) {
    try {
      const existingData = state.noFreightTransporterList;
      if (existingData.length > 0) {
        return existingData;
      }
      const result = await getActiveTransporters();
      if (result && result.data) {
        commit('SET_NO_FREIGHT_TRANSPORTERS', result.data);
      }
      return result && result.data;
    } catch (error) {
      return error;
    }
  },
  async searchTransporters({ commit }, { params }) {
    try {
      const result = await tmsMdmAxiosInstance('/transporter/search', { params });
      if (result && result.data) {
        commit('SET_MASTER_TRANSPORTER_LIST', result.data);
      }
      return result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async searchMdmGates({ commit }, { params }) {
    try {
      const result = await tmsIndentAxiosInstance('/order/search_depot_gates', { params });
      if (result && result.data) {
        commit('SET_MDM_GATE_LIST', result.data);
      }
      return result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async createReturnRequest({ commit }, payload) {
    try {
      const result = await axios.post('planning/create_request', { data: payload });
      return (result && result.data) ? result.data : null;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async getRequests({ commit }, { params }) {
    try {
      const result = await axios.get('planning/requests', { params });
      if (result && !result.error) {
        if (result.data && result.data.length) {
          commit('APPEND_REQUESTS', result.data);
        } else {
          commit('PAGINATION_CHECK', true);
        }
      }
      return result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async rejectRequest({ commit }, payload) {
    try {
      const result = await axios.post('planning/reject_request', { data: payload });
      return (result && result.data) ? result.data : null;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async createIndent({ commit }, payload) {
    try {
      const result = await axios.post('planning/indent', { data: payload });
      return (result && result.data) ? result.data : null;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async getDeliveriesCount({ commit }, { params }) {
    try {
      const result = await axios.get('/deliveries_count', { params });
      return result;
    } catch (err) {
      throw err;
    }
  },
};

export default actions;
